<template>
  <div class=" is-fullwidth">
    <div class="level">
      <div class="level-left">
        <router-link to="/finance/add-internal-order" ><button class="button is-success">Create a New Order</button></router-link>
      </div> 
      <div class="level-right">
          <div class="columns" >
              
             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              
        </div>
      </div>
    </div>

    

        <div class="notification is-info" v-if="loading === true">
            <p>Loading orders ...</p>
        </div>

        <div class="notification is-warning" v-if="loading === false && internal_orders.length == 0">
            <p>There are no orders to display</p>
        </div>
    
    <table class="table is-hoverable is-fullwidth" id="orderstable" v-if="loading === false && internal_orders.length > 0">
    	<thead>
    		
        <th>Date</th>
   	 		<th>Product</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Unit Cost</th>
          <th>Total</th>
          <th width="50">&nbsp;</th>
          
    	</thead>
    	<tbody>
		    
            
            <tr v-for="row in internal_orders" v-bind:key="row.id">
         
                <td >{{row.date}}</td>
          <td >{{row.internal_product_name}}</td>
          <td>{{ row.description }}</td>
          <td>{{row.quantity}}</td>
          <td>&pound;{{ formatPrice(row.unit_price) }}</td>
          <td>&pound;{{ formatPrice(row.unit_price * row.quantity) }}</td>
          
          <td>
                <div class="buttons has-addons ">
                  
               </div>
            </td>
          
              
			</tr>
    	</tbody>
    </table>

    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       internal_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      start_date: '',
        end_date: '',
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getInternalOrders(this.accessToken, this.start_date, this.end_date)
        .then(
          (internal_orders => {
            this.$set(this, "internal_orders", internal_orders);
            this.loading=false
          }).bind(this)
        );
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)// .replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 31);
            return d.toISOString().slice(0,10);
             
        },
    
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.completed == 1) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.internal_orders_start_date) {
      this.start_date = localStorage.internal_orders_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.internal_orders_end_date) {
      this.end_date = localStorage.internal_orders_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }
      
  },
  watch: {
    
    start_date: function () {
      localStorage.internal_orders_start_date = this.start_date;
      this.internal_orders = []
      this.getOrders()
    },
    end_date: function () {
      localStorage.internal_orders_end_date = this.end_date;
      this.internal_orders = []
      this.getOrders()
    },
   
  }
}


</script>

